import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
}

const PreviousPage = (props: Props): ReactElement => {
  const { width, height } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 17 20">
      <path d="M13.352,0.358c1.04,-0.67 2.424,-0.373 3.092,0.665c0.194,0.302 0.312,0.645 0.346,1l0.01,0.214l-0.033,15.45c-0.003,1.237 -1.007,2.24 -2.244,2.24c-0.33,0 -0.655,-0.072 -0.952,-0.212l-0.217,-0.117l-12.257,-7.52c-1.053,-0.645 -1.38,-2.023 -0.732,-3.078c0.14,-0.228 0.321,-0.43 0.532,-0.594l0.164,-0.116l12.29,-7.932l0.001,0Zm1.821,1.452c-0.202,-0.29 -0.58,-0.394 -0.899,-0.26l-0.116,0.062l-12.29,7.93c-0.095,0.061 -0.174,0.142 -0.233,0.238c-0.192,0.312 -0.127,0.71 0.136,0.945l0.108,0.08l12.258,7.52c0.117,0.072 0.252,0.11 0.39,0.11c0.37,0 0.679,-0.27 0.737,-0.625l0.01,-0.121l0.033,-15.451c0,-0.108 -0.022,-0.214 -0.067,-0.31l-0.067,-0.118Z" />
    </svg>
  );
};

PreviousPage.defaultProps = {
  width: '100%',
  height: '100%',
};

export default PreviousPage;
